/* FURTAGE Concierge (sections/furtage-concierge.liquid)
   1. Beim Absenden: jede Pflichtgruppe braucht eine Auswahl, Name und E-Mail müssen stimmen.
      Fehlt etwas, erscheint der Hinweis direkt an der Stelle und nichts wird abgeschickt.
   2. Lehnt Shopify die Anfrage ab (z. B. E-Mail ungültig), kommt die Auswahl der Chips zurück.
   Ohne JavaScript bleiben es normale Checkboxen; der Browser prüft dann Radio, Name und E-Mail. */
if (!customElements.get('furtage-concierge')) {
  const STORAGE_KEY = 'furtage-concierge-selection';

  const storage = {
    get() {
      try {
        const value = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || '[]');
        return Array.isArray(value) ? value : [];
      } catch (e) {
        return [];
      }
    },
    set(value) {
      try {
        window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(value));
      } catch (e) {}
    },
    clear() {
      try {
        window.sessionStorage.removeItem(STORAGE_KEY);
      } catch (e) {}
    },
  };

  customElements.define(
    'furtage-concierge',
    class FurtageConcierge extends HTMLElement {
      connectedCallback() {
        if (this.querySelector('[data-concierge-success]')) storage.clear();

        this.form = this.querySelector('form');
        if (!this.form || !this.querySelector('[data-required-group]')) return;

        if (this.querySelector('[data-concierge-errors]')) this.restoreSelection();

        this.form.noValidate = true;
        this.form.addEventListener('submit', (event) => this.onSubmit(event));
        this.form.addEventListener('change', (event) => this.recheck(event.target));
        this.form.addEventListener('input', (event) => this.recheck(event.target));
      }

      get checks() {
        return Array.from(this.querySelectorAll('[data-required-group], [data-required-field]'));
      }

      isValid(container) {
        if (container.hasAttribute('data-required-group')) {
          return Boolean(container.querySelector('input:checked'));
        }
        const input = container.querySelector('input');
        return input.value.trim() !== '' && input.checkValidity();
      }

      show(container, valid) {
        const message = container.querySelector('[data-error]');
        if (!message) return;
        message.hidden = valid;
        container.toggleAttribute('data-invalid', !valid);
        container.querySelectorAll('input').forEach((input) => {
          const ids = (input.getAttribute('aria-describedby') || '').split(' ').filter((id) => id && id !== message.id);
          if (!valid) ids.push(message.id);
          if (ids.length) input.setAttribute('aria-describedby', ids.join(' '));
          else input.removeAttribute('aria-describedby');
          if (container.hasAttribute('data-required-field')) {
            if (valid) input.removeAttribute('aria-invalid');
            else input.setAttribute('aria-invalid', 'true');
          }
        });
      }

      recheck(target) {
        const container = target.closest('[data-invalid]');
        if (container && this.isValid(container)) this.show(container, true);
      }

      onSubmit(event) {
        let firstInvalid = null;
        this.checks.forEach((container) => {
          const valid = this.isValid(container);
          this.show(container, valid);
          if (!valid && !firstInvalid) firstInvalid = container;
        });

        if (firstInvalid) {
          event.preventDefault();
          firstInvalid.scrollIntoView({ block: 'center' });
          const input = firstInvalid.querySelector('input');
          if (input) input.focus({ preventScroll: true });
          return;
        }

        storage.set(
          Array.from(this.form.querySelectorAll('.furtage-concierge__chip-input:checked')).map((input) => [
            input.name,
            input.value,
          ])
        );
      }

      restoreSelection() {
        const saved = storage.get();
        this.querySelectorAll('.furtage-concierge__chip-input').forEach((input) => {
          if (saved.some(([name, value]) => name === input.name && value === input.value)) input.checked = true;
        });
      }
    }
  );
}
